import { Injectable } from '@angular/core'
import { StorageService } from '@sun-finance/utils'

const BUSINESS_MODE_STORAGE_KEY = 'business_mode'

@Injectable({
  providedIn: 'root'
})
export class BusinessModeToggleService {

  constructor(private storage: StorageService) { }

  get isOn() {
    return !!this.storage.get(BUSINESS_MODE_STORAGE_KEY)
  }

  get isOff() {
    return !this.isOn
  }

  turnOn(): void {
    this.storage.set(BUSINESS_MODE_STORAGE_KEY, BUSINESS_MODE_STORAGE_KEY)
  }

  turnOff(): void {
    this.storage.clear(BUSINESS_MODE_STORAGE_KEY)
  }
}
